import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth, returnPath } from '../context/AuthContext';
import SignInReason from './account/SignInReason';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loginAttempted, setLoginAttempted] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const { login, error: apiError, clearError, loading, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log({apiError})
  }, [apiError])
  useEffect(() => {
    clearError();
    return () => {
      setFormErrors({});
    };
  }, [clearError]);

  useEffect(() => {
    if (loginAttempted && user) {
      navigate(returnPath(location.state?.from), { replace: true });
    }
  }, [loginAttempted, user, navigate, location]);

  const validateForm = () => {
    const errors = {};
    if (!username.trim()) {
      errors.username = 'Username is required';
    }
    if (!password.trim()) {
      errors.password = 'Password is required';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    setLoginAttempted(false);
    try {
      await login(username, password, rememberMe);

      setLoginAttempted(true);
    } catch (error) {
      console.error('Login error:', error);
      setLoginAttempted(true);
    }
  };

  const handleBlur = (field) => {
    const errors = { ...formErrors };
    if (!field.trim()) {
      errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else {
      delete errors[field];
    }
    setFormErrors(errors);
  };

  return (
    <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl">
      <SignInReason from={location.state?.from} mode="login" />
      <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
      {(apiError || Object.keys(formErrors).length > 0) && (
        <div className="text-red-500 text-sm mb-4 text-center">
          {apiError && <p>{apiError}</p>}
          {Object.values(formErrors).map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="username" className="block text-gray-700 text-sm font-bold mb-2">Username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onBlur={() => handleBlur('username')}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="mb-6">
          <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onBlur={() => handleBlur('password')}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="mb-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="mr-2"
            />
            <span className="text-sm">Remember me</span>
          </label>
        </div>
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
          <Link to="/forgot-password" className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800">
            Forgot Password?
          </Link>
        </div>
      </form>
      <p className="mt-4 text-center text-sm">
        Don't have an account? <Link to="/register" state={location.state?.from ? { from: location.state.from } : undefined} className="font-bold text-blue-500 hover:text-blue-800">Register here</Link>
      </p>
    </div>
  );
};

export default Login;